<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item" v-for="(item, index) in masterInfoList" :key="index">
            <span class="basic_title">{{ item.name }}</span>
            <span class="basic_txt">{{ detailsData[item.paramsKey] }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--费用明细-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <div class="flex align-items-center">
            <h2 class="title_box mr30">{{ $t('key1003683') }}</h2>
            <local-tabButton :tabButtonList="costTypeList" @selectStatus="costTypeBtn"></local-tabButton>
            <Tooltip max-width="300" placement="top" class="ml12 cursor" transfer
              :content="$t('key1007051')">
              <Icon size="18" type="md-help-circle"/>
            </Tooltip>
          </div>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="650"
            :loading="tableLoading"
            :columns="deliveryOrderColumns"
            :data="deliveryOrderData">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            @on-change="changePage"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="changePageSize"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getDataSetBatchList, getEnumList, setConfigCharacters} from "@/utils/common";

export default {
  name: 'reconciliationBillDetails',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 8,
      pageParamsStatus: false,
      columnsList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003655'),
          key: 'costType',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let text = '';
            v.billFeeTypeList.map((item) => {
              if (item.value === params.row.type) {
                text = item.title;
              }
            })
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'),
          key: 'supplierPackageCode',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003652'),
          key: 'supplierLogisticsAmount',
          minWidth: 180,
          align: 'center',
          renderHeader(h, params) {
            return h('span', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003652')}(${v.currencyState})`)
          },
          render(h, params) {
            let supplierLogisticsAmount = params.row.supplierLogisticsAmount;
            return supplierLogisticsAmount ? h('div', [
              h('div', v.formatCurrency(params.row.supplierLogisticsAmount)),
              h('div', '(' + v.currencyState + ')')
            ]) : '';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213'),
          key: 'orderProcessingFee',
          minWidth: 180,
          align: 'center',
          renderHeader(h, params) {
            return h('span', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213')}(${v.currencyState})`)
          },
          render(h, params) {
            let orderProcessingFee = params.row.amount;
            return orderProcessingFee ? h('div', [
              h('div', v.formatCurrency(orderProcessingFee)),
              h('div', '(' + v.currencyState + ')')
            ]) : '';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093'),
          key: 'supplierSpu',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
          key: 'supplierSku',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003656'),
          key: 'quantity',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003657'),
          key: 'thirtyVolumes',
          minWidth: 170,
          align: 'center'
        },
        {
          title: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882')}(${v.currencyState})`,
          key: 'originalSuggestPrice',
          align: 'center',
          minWidth: 140,
          renderHeader(h, params) {
            return h('span', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007046')}(${v.currencyState})`)
          },
          render(h, params) {
            let originalSuggestPrice = params.row.originalSuggestPrice;
            return originalSuggestPrice ? h('div', [
              h('div', v.formatCurrency(originalSuggestPrice)),
              h('div', '(' + v.currencyState + ')')
            ]) : '';
          }
        },
        {
          title: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003653')}(${v.currencyState})`,
          key: 'schemePrice',
          minWidth: 160,
          align: 'center',
          renderHeader(h, params) {
            return h('span', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003653')}(${v.currencyState})`)
          },
          render(h, params) {
            let schemePrice = params.row.schemePrice;
            return schemePrice ? h('div', [
              h('div', v.formatCurrency(params.row.schemePrice)),
              h('div', '(' + v.currencyState + ')')
            ]) : '';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003654'),
          key: 'totalAmount',
          minWidth: 180,
          align: 'center',
          renderHeader(h, params) {
            return h('span', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003654')}(${v.currencyState})`)
          },
          render(h, params) {
            let totalAmount = params.row.totalAmount;
            return totalAmount ? h('div', [
              h('div', v.formatCurrency(params.row.totalAmount)),
              h('div', '(' + v.currencyState + ')')
            ]) : '';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003658'),
          key: 'supplierPickupOrderNumber',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003659'),
          key: 'boxedTime',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let time = params.row.boxedTime;
            time = time ? v.$uDate.dealTime(time, 'fulltime') : ''
            return h('span', time)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003660'),
          key: 'pickupTime',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let time = params.row.pickupTime;
            time = time ? v.$uDate.dealTime(time, 'fulltime') : ''
            return h('span', time)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002451'),
          key: 'shipedTime',
          align: 'center',
          minWidth: 170,
          renderHeader(h) {
            return h('span', v.pageParams.type === 3 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003661') : `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565')}`)
          },
          render(h, params) {
            let time = params.row.shipedTime;
            time = time ? v.$uDate.dealTime(time, 'fulltime') : ''
            return h('span', time)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003619'),
          key: 'createdTime',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let time = params.row.createdTime;
            time = time ? v.$uDate.dealTime(time, 'fulltime') : ''
            return h('span', time)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003663'),
          key: 'packageCreatedTime',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let time = params.row.packageCreatedTime;
            time = time ? v.$uDate.dealTime(time, 'fulltime') : ''
            return h('span', time)
          }
        },
      ],
      deliveryOrderColumns: [],
      deliveryOrderData: [],
      queryCarrierShippingName: [],
      total: 0,
      pageParams: {
        pageNum: 1,
        pageSize: 15,
        type: 0
      },
      detailsData: {},
      masterInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003685'), paramsKey: 'billNo'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003667'), paramsKey: 'totalPrice'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003665'), paramsKey: 'statusTxt'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003593'), paramsKey: 'billingCycle'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003594'), paramsKey: 'billGenerationTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003666'), paramsKey: 'lastUpdateTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007047'), paramsKey: 'totalCostAmount'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007048'), paramsKey: 'subsidyCostAmount'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007049'), paramsKey: 'logisticsCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007050'), paramsKey: 'supplierLogisticsAmount'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003672'), paramsKey: 'totalHandelAmount'},
      ],
      costTypeList: [
        {selected: true, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003673')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003674')},
        {selected: false, value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675')},
        {selected: false, value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003652')},
        {selected: false, value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213')}
      ],
      enumData: []
    };
  },
  computed: {
    settlementStatusList() {
      const ENUM_KEY = 'YmsBillStatusSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 账单费用类型
    billFeeTypeList() {
      const ENUM_KEY = 'YmsBillPackageDetailTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    }
  },
  created() {
   this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList =['YmsBillStatusSupplierEnum', 'YmsBillPackageDetailTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.handlerInfo();
      this.costTypeBtn(0, 0);
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/reconciliationManage');
    },
    // 处理基本信息的数据
    handlerInfo() {
      let v = this;
      v.axios.get(api.get_ymsSupplierBill_supplierBillDetail + v.$route.query.ymsBillId).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let keyList = ['totalPrice', 'totalCostAmount', 'subsidyCostAmount', 'logisticsCost', 'supplierLogisticsAmount', 'totalHandelAmount'];
            keyList.map((key) => {
              data[key] = v.formatCurrency(data[key]) + `（${v.currencyState}）`
            });
            v.settlementStatusList.map((item) => {
              if (item.value === data.status) {
                data.statusTxt = item.title;
              }
            });
            let startTime = data.periodStartTime;
            let endTime = data.periodEndTime;
            if (startTime && endTime) {
              let periodStartTime = v.$uDate.dealTime(startTime);
              let periodEndTime = v.$uDate.dealTime(endTime);
              data.billingCycle = periodStartTime + ' - ' + periodEndTime;
            }
            data.billGenerationTime = data.createdTime ? v.$uDate.dealTime(data.createdTime, 'fulltime') : '';
            data.lastUpdateTime = data.updatedTime ? v.$uDate.dealTime(data.updatedTime, 'fulltime') : '';
            v.detailsData = data;
          }
        }
      });
    },
    // 获取出库单详情的数据
    getDetailsData() {
      let v = this;
      v.deliveryOrderData = [];
      v.tableLoading = true;
      let query = {
        pageNum: v.pageParams.pageNum,
        pageSize: v.pageParams.pageSize,
        ymsBillId: v.$route.query.ymsBillId,
        type: v.pageParams.type,
      };
      v.axios.get(api.supplier_get_ymsPackageDetail_api_queryBillId, {params: query}).then((response) => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.total = data.total;
          v.deliveryOrderData = data.list || [];
        }
      });
    },
    // 费用明细类型筛选
    costTypeBtn(index, value) {
      const COLUMN_RULE_MAP = {
        0: {
          exclude: ['supplierLogisticsAmount', 'orderProcessingFee', 'packageCreatedTime']
        },
        1: {
          include: [
            'costType',
            'totalAmount',
            'supplierPickupOrderNumber',
            'boxedTime',
            'pickupTime',
            'createdTime'
          ]
        },
        2: {
          include: [
            'costType',
            'totalAmount',
            'supplierPickupOrderNumber',
            'boxedTime',
            'pickupTime',
            'createdTime'
          ]
        },
        3: {
          include: [
            'costType',
            'supplierPackageCode',
            'supplierLogisticsAmount',
            'packageCreatedTime',
            'shipedTime',
            'createdTime'
          ]
        },
        4: {
          include: [
            'costType',
            'supplierPackageCode',
            'orderProcessingFee',
            'packageCreatedTime',
            'shipedTime',
            'createdTime'
          ]
        }
      };
      const rule = COLUMN_RULE_MAP[value];

      if (rule?.include) {
        this.deliveryOrderColumns = this.columnsList.filter(col =>
          rule.include.includes(col.key)
        );
      } else if (rule?.exclude) {
        this.deliveryOrderColumns = this.columnsList.filter(col =>
          !rule.exclude.includes(col.key)
        );
      } else {
        this.deliveryOrderColumns = this.columnsList;
      }

      // 更新参数
      this.pageParams.type = value;
      this.pageParamsStatus = true;

      // 按钮选中态
      this.costTypeList.forEach((item, idx) => {
        item.selected = index === idx;
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getDetailsData();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style scoped>

</style>
